export const isChakraName = (name) => {
    return typeof name === 'string' && (name.includes('.') || name.includes('-'));
};
export const getChakraVar = (type, name) => {
    return `--chakra-${type}-${name.replace(/\.+/g, '-')}`;
};
export const getChakraVarExpression = (type, name) => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return `var(${getChakraVar(type, name)})`;
};
